import {getAxios} from '../../axiosWithToken'

export const postPaypal = body => getAxios().post('payments/paypal/', body)

export const postOmise = body =>
    getAxios().post(`payments/omise/`, body)

export const postInternetBanking = body => getAxios().post('payments/omise/internet-banking/', body)



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/payment/index.js